import * as React from 'react'
import DatePicker, { registerLocale } from 'react-datepicker-styled-components'
import ja from 'date-fns/locale/ja'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  readonly locale: string
  readonly defaultDateTime?: Date
  readonly onChanged?: (date: any) => void
}

export default function DateTimePicker({ locale, defaultDateTime, onChanged }: Props) {
  const initialDate = defaultDateTime ? defaultDateTime : new Date()
  const [startDate, setStartDate] = React.useState(initialDate)
  const handleChange = (date: any) => {
    setStartDate(date)
    if (onChanged) {
      onChanged(date)
    }
  }

  if (locale == 'ja') {
    registerLocale(locale, ja)
  }

  return (
    <DatePicker
      locale={locale}
      selected={startDate}
      onChange={handleChange}
      dateFormat="yyyy/MM/dd HH:mm"
      showTimeSelect
      timeFormat="HH:mm"
      timeIntervals={30}
    />
  )
}
